import React, { Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Input } from 'reactstrap';
import { H4 } from '../../../../AbstractElements';
import { CheckOut, ContinueShopping, TotalPrice } from '../../../../Constant';
import { postDataWithToken } from '../../../../Utils/restUtils';
import { deliveryCharge } from '../../../../CommonUrl';
import { toast } from 'react-toastify';

const CartAction = ({ cart, total }) => {
    const Navigate = useNavigate();

    const checkout = async () => {
        const items = cart.map(({ item_id, quantity }) => ({ item_id, quantity }));
        const postRequest = { items: items }
        const response = await postDataWithToken(deliveryCharge, postRequest);
        if (response.data.status) {
            if (response?.data?.data) {
                const checkoutDetails = response.data.data;
                const cartIds = cart.map(item => item.cart_id);
                Navigate(`${process.env.PUBLIC_URL}/checkout`, { state: { checkoutDetails, total, cartIds } });

            }
            else {

                toast.error(response.data.message);
            }
        } else {
            toast.error(response.data.message);
        }
    }
    return (
        <Fragment>
            <tr>
                <td colSpan="4">
                    {/* <div className="input-group">
                    <Input className="form-control" type="text" placeholder="Enter coupon code" /><a className="btn btn-primary text-white" href="#javascript">{Apply}</a>
                </div> */}
                </td>
                <td className="total-amount"><H4 attrH4={{ className: 'm-0 text-end' }}><span className="f-w-600">{TotalPrice} :</span></H4>
                </td>
                <td><span>${total}</span></td>
            </tr>
            <tr>
                <td className="text-end" colSpan="5"><Link to={`${process.env.PUBLIC_URL}/product`} className="btn btn-secondary cart-btn-transform">{ContinueShopping}</Link></td>
                <td><div className="btn btn-success cart-btn-transform" onClick={() => checkout()}>{CheckOut}</div></td>
            </tr>
        </Fragment>
    )
}

export default CartAction